// extracted by css-extract-rspack-plugin
export default {"spaceMedium":"20px","spaceFluid":"100%","panelBody":"on-behalf-evaluation__panelBody___SbzmJ","onBehalfOfUser":"on-behalf-evaluation__onBehalfOfUser___CdqDB"};